export enum Role {
  COMPANY_ADMIN = "company_admin",
  YAMAS_GATE_MANAGER = "yamas_gateManager",
  YAMAS_WAREHOUSE_MANAGER = "yamas_warehouseManager",
}
